import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=3c2906e3&"
import script from "./ContactsTable.vue?vue&type=script&lang=ts&"
export * from "./ContactsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports